import { BaseStore } from './BaseStore';
import { Action } from '../Dispatcher';
import { ActionType, ActionData } from '../actions/ActionTypes';
import { ActionCreator } from '../actions/ActionCreator';
import { WebApiUtils } from '../utils/WebApiUtils';

export interface IApplicationStoreState {
    merchantId?: string,
    terminalId?: string,
    isSelected: boolean,
    sendResponses: boolean,

    isModalDialogShown?: boolean,
    modalDialogMessage?: string,
    isYesNoModalDialogShown: boolean,
    yesNoModalDialogMessage: string,

    communicationData?: Array<IActionData>,
    configurationData?: Array<IConfigurationData>
}

var FOLDER_NOT_EXISTS = 'FOLDER_NOT_EXISTS';
var FILE_NOT_FOUND = 'FILE_NOT_FOUND';

export class ApplicationStore extends BaseStore {

    private state: IApplicationStoreState;
    private communicationPeriodicRequetsTurnedOn: boolean;

    constructor() {
        super();

        this.state = {
            merchantId: null,
            terminalId: null,
            isSelected: false,
            sendResponses: true,

            isModalDialogShown: false,
            modalDialogMessage: null,
            isYesNoModalDialogShown: false,
            yesNoModalDialogMessage: null,

            communicationData: [],
            configurationData: []
        };
        this.communicationPeriodicRequetsTurnedOn = false;
    }

    public getState(): IApplicationStoreState {
        return this.state;
    }

    public onAction(action: Action): void {
        var doEmit: boolean = false;

        switch (action.actionType) {
            case ActionType.TOGGLE_RESPONSES:
                {
                    let data = <ActionData.ToggleResponseData>action.data;

                    WebApiUtils.toggleSendResponses(data.merchantId, data.terminalId, data.value);
                    break;
                }
            case ActionType.TOGGLE_RESPONSES_DATA:
                {
                    let data = <ActionData.WebApiResponse>action.data;

                    this.state.sendResponses = data.data;

                    doEmit = true;
                    break;
                }
            case ActionType.IDENT_SELECTION:
                {
                    let data = <ActionData.IdentitySelectionData>action.data;

                    if (this.communicationPeriodicRequetsTurnedOn
                        && (data.merchantId !== this.state.merchantId || data.terminalId !== this.state.terminalId)) {
                        if (!WebApiUtils.stopPeriodicCommunicationDataRequest[this.state.merchantId]) {
                            WebApiUtils.stopPeriodicCommunicationDataRequest[this.state.merchantId] = {};
                        }
                        WebApiUtils.stopPeriodicCommunicationDataRequest[this.state.merchantId][this.state.terminalId] = true;
                        this.communicationPeriodicRequetsTurnedOn = false;
                    }

                    WebApiUtils.getCommunicationData(data.merchantId, data.terminalId);
                    WebApiUtils.getConfigurationData(data.merchantId, data.terminalId);
                    this.state.isSelected = true;
                    this.state.merchantId = data.merchantId;
                    this.state.terminalId = data.terminalId;
                    this.state.communicationData = [];
                    this.state.configurationData = [];
                    doEmit = true;
                    break;
                }
            case ActionType.GET_COMMUNICATION_DATA:
                {
                    let data = <ActionData.WebApiResponse>action.data;

                    if (data.params.merchantId !== this.state.merchantId
                        || data.params.terminalId !== this.state.terminalId) {
                        break;
                    }

                    if (data.data !== FOLDER_NOT_EXISTS) {
                        this.state.communicationData = data.data;
                        if (!this.communicationPeriodicRequetsTurnedOn) {
                            WebApiUtils.getCommunicationDataPeriodically(this.state.merchantId, this.state.terminalId);
                            this.communicationPeriodicRequetsTurnedOn = true;
                        }
                    }
                    else {
                        this.state.isYesNoModalDialogShown = true;
                        this.state.yesNoModalDialogMessage = "Merchant '" + this.state.merchantId + "' and terminal '" + this.state.terminalId + "' not found.<br/>Do you want to create folder and default data?";
                        this.state.isSelected = false;
                    }
                    doEmit = true;
                    break;
                }
            case ActionType.GET_CONFIGURATION_DATA:
                {
                    let data = <ActionData.WebApiResponse>action.data;

                    if (data.data !== FOLDER_NOT_EXISTS) {
                        this.state.sendResponses = data.data.SendResponses;
                        this.state.configurationData = data.data.Data;
                    }
                    doEmit = true;
                    break;
                }
            case ActionType.MODAL_CLOSE:
                {
                    this.state.isModalDialogShown = false;
                    this.state.modalDialogMessage = null;
                    doEmit = true;
                    break;
                }
            case ActionType.YESNO_MODAL_CLOSE:
                {
                    this.state.isYesNoModalDialogShown = false;
                    this.state.yesNoModalDialogMessage = null;
                    doEmit = true;
                    break;
                }
            case ActionType.CREATE_FOLDERS:
                {
                    WebApiUtils.createFolders(this.state.merchantId, this.state.terminalId);
                    break;
                }
            case ActionType.REST_CREATE_FOLDERS:
                {
                    ActionCreator.identitySelection(this.state.merchantId, this.state.terminalId);
                    break;
                }
            case ActionType.SAVE_CONFIGURATION:
                {
                    let data = <ActionData.ConfigurationData>action.data;
                    WebApiUtils.saveConfiguration(data);
                    break;
                }
            case ActionType.DELETE_CONFIGURATION:
                {
                    let data = <ActionData.ConfigurationData>action.data;
                    WebApiUtils.deleteConfiguration(data);
                    break;
                }
            case ActionType.REST_SAVE_CONFIGURATION:
            case ActionType.REST_DELETE_CONFIGURATION:
                {
                    let data = <ActionData.WebApiResponse>action.data;
                    if (data.data === FILE_NOT_FOUND) {
                        this.state.isModalDialogShown = true;
                        this.state.modalDialogMessage = data.data;
                        doEmit = true;
                        break;
                    } else {
                        WebApiUtils.getConfigurationData(this.state.merchantId, this.state.terminalId);
                    }
                    break;
                }
            case ActionType.WEBAPI_ERROR:
            case ActionType.TIMEOUT:
                {
                    let data = <ActionData.WebApiResponse>action.data;
                    this.state.isModalDialogShown = true;
                    this.state.modalDialogMessage = action.actionType === ActionType.TIMEOUT
                        ? `Timeout for action: '${ActionType[data.data.originalActionType]}'`
                        : `'${data.data.text}' response for action: '${ActionType[data.data.originalActionType]}'`;
                    doEmit = true;
                    break;
                }
            case ActionType.DOWNLOAD_CONFIGURATION_FILES:
                {
                    let data = <ActionData.ConfigurationFilesDownload>action.data;
                    WebApiUtils.downloadConfigurationFiles(data);
                    break;
                }
            case ActionType.UPLOAD_CONFIGURATION_FILES:
                {
                    let data = <ActionData.ConfigurationFilesUpload>action.data;
                    WebApiUtils.uploadConfigurationFiles(data);
                    break;
                }
            case ActionType.REST_UPLOAD_CONFIGURATION_FILES:
                {
                    let data = (<ActionData.WebApiResponse>action.data).data;
                    WebApiUtils.getConfigurationData(data.merchantId, data.terminalId);
                    break;
                }
        }

        if (doEmit) {
            this.emitChange();
        }
    }
};

export var applicationStore: ApplicationStore = new ApplicationStore();


// WEBPACK FOOTER //
// ./Scripts/stores/ApplicationStore.ts